import React, { useState } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import Froala from '@/components/shared/Froala';
import { PanelFooter, hintClass, panelClass } from '../../shared/formPanel';
import SPASectionHeading from '../../shared/SPASectionHeading';
import { useSPAToast } from '../../shared/SPAToast';
import { EditableUnit, useUpdateUnit } from './useUnit';

// The legacy form's toolbar for this field.
const FROALA_CONFIG = {
  toolbarButtons: [
    'bold', 'italic', 'underline', 'textColor', 'backgroundColor', 'paragraphFormat',
    'strikeThrough', 'subscript', 'superscript', 'formatOL', 'formatUL', 'insertLink',
    'undo', 'redo', 'clearFormatting', 'selectAll', 'html',
  ],
};

const UnitDescriptionPanel = () => {
  const unit = useOutletContext<EditableUnit>();
  const { programId } = useParams<{ programId: string }>();
  const spaToast = useSPAToast();
  const updateUnit = useUpdateUnit(Number(programId), unit.id);
  const [html, setHtml] = useState(unit.unit_projects_description_en ?? '');

  const save = (event: React.FormEvent) => {
    event.preventDefault();
    updateUnit.mutate({ unit: { unit_projects_description_en: html } }, {
      onSuccess: () => spaToast.success('Saved the unit projects description.'),
    });
  };

  return (
    <form noValidate className={panelClass} onSubmit={save}>
      <SPASectionHeading className="tw-mb-1" title="Unit Projects Description" />
      <span className={`${hintClass} tw-mb-3 tw-mt-0`}>
        Shown in the Unit Projects card on the unit overview page.
      </span>
      {/* The editor keeps its light styling; students and teachers read this on light pages. */}
      <div className="tw-rounded tw-bg-white tw-text-neutral-900">
        <Froala
          customConfig={FROALA_CONFIG}
          modelId={unit.id}
          modelType="Unit"
          name="unit_projects_description_en"
          text={html}
          userType="Sysadmin"
          onChange={setHtml}
        />
      </div>
      <PanelFooter update={updateUnit} />
    </form>
  );
};

export default UnitDescriptionPanel;
